import { css } from "@emotion/react";

import { Button, Tooltip } from "@livechat/design-system-react-components";

import { disabledActivationButtonStyles } from "./styles";

type ICustomFieldStatusButtonProps = {
  id: string;
  isAdmin: boolean;
  deactivated: boolean;
  canActivateCustomField: boolean;
  displayName: string;
  handleActivate: (id: string) => void;
  toggleDeactivateModal: (id: string) => void;
};

export const CustomFieldStatusButton = ({
  id,
  isAdmin,
  deactivated,
  canActivateCustomField,
  displayName,
  handleActivate,
  toggleDeactivateModal,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
}: ICustomFieldStatusButtonProps) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const renderStatusButtonContent = (deactivated: boolean, canActivateCustomField: boolean) => {
    if (deactivated) {
      if (!canActivateCustomField) {
        return (
          <Tooltip placement="top" triggerRenderer={() => "Activate"} theme="invert" css={css({ width: "246px" })}>
            <span>You can&apos;t activate this custom field because you&apos;ve reached the custom field limit.</span>
          </Tooltip>
        );
      }
      return "Activate";
    }
    return "Deactivate";
  };
  return (
    <Button
      kind="link-light"
      disabled={!isAdmin || (deactivated && !canActivateCustomField)}
      data-testid={`delete-custom-field-action-${displayName}`}
      css={!canActivateCustomField && deactivated && disabledActivationButtonStyles}
      onClick={() => (deactivated ? handleActivate(id) : toggleDeactivateModal(id))}
    >
      {renderStatusButtonContent(deactivated, canActivateCustomField)}
    </Button>
  );
};
